<template>
  <div>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'default'
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/default.vue